import React, {useState, Suspense} from 'react'
import {Route, Switch} from 'react-router-dom'
import styles from './styles.css'
import InboxList from './InboxList'
import UserMenu from './UserMenu'
import Conversation, {Fallback as ConversationFallback} from './Conversation'
import Vehicle, {Fallback as VehicleFallback} from './Vehicle'
import NoChats from './NoChats'
import ConversationList, {Fallback} from './ConversationList'
import InboxConfiguration from './Configuration'
import useForceLogin from 'App/hooks/useForceLogin'
import useSession from 'App/hooks/useSession'

import useQuery from 'apollo-hooks/lib/useApolloQuery'
import gql from 'graphql-tag'

const priorityOptions = [
  {
    label: 'Más nuevo',
    value: 'newerFirst'
  },
  {
    label: 'Más antiguo',
    value: 'olderFirst'
  },
  {
    label: 'Más urgentes (prioridad)',
    value: 'priorityFirst'
  },
  {
    label: 'Esperando más tiempo',
    value: 'mostWaitingFirst'
  }
]

export default function Inbox({history, match}) {
  const {conversationId, vehicleId} = match.params

  useForceLogin()
  const session = useSession()

  const [sortBy, setSortBy] = useState('priorityFirst')
  const [showInboxList, setShowInboxList] = useState(true)
  const [showConfig, setShowConfig] = useState(false)
  const [inboxId, setInboxId] = useState(session.userId)

  const {inboxes} = useQuery({
    query: gql`
      query getInboxes {
        inboxes: activeConversationsCount {
          _id
          type
          name
          count
        }
      }
    `,
    pollInterval: 10000
  })

  const inbox = (inboxes || []).find(({_id}) => inboxId === _id)

  if (!(session.roles || []).includes('operator')) return 'no permissions'

  return (
    <div className={styles.container}>
      <UserMenu />
      <InboxList
        showInboxList={showInboxList}
        inboxes={inboxes}
        onInboxClick={id => {
          setInboxId(id)
          setShowConfig(false)
        }}
        onConfigClick={() => {
          setShowConfig(true)
        }}
        configSelected={showConfig}
        inboxId={inboxId}
        displayConfiguration={session.roles.includes('driverManager')}
      />

      {showConfig ? (
        <InboxConfiguration />
      ) : (
        <>
          <Suspense
            loading
            fallback={
              <Fallback
                inbox={inbox}
                showInboxList={showInboxList}
                toggleSidebar={() => setShowInboxList(value => !value)}
                options={priorityOptions}
                sortBy={sortBy}
              />
            }>
            <ConversationList
              conversationId={conversationId}
              vehicleId={vehicleId}
              history={history}
              options={priorityOptions}
              sortBy={sortBy}
              setSortBy={setSortBy}
              inbox={inbox}
              toggleSidebar={() => setShowInboxList(value => !value)}
            />
          </Suspense>
          <Switch>
            <Route path="/inbox" exact component={NoChats} />
            <Route
              path="/inbox/vehicles/:vehicleId"
              render={props => (
                <Suspense fallback={<VehicleFallback />}>
                  <Vehicle {...props} />
                </Suspense>
              )}
            />
            <Route
              path="/inbox/conversations/:conversationId"
              render={props => (
                <Suspense fallback={<ConversationFallback />}>
                  <Conversation
                    {...props}
                    priorityOptions={priorityOptions}
                    sortBy={sortBy}
                    setSortBy={setSortBy}
                    inbox={inbox}
                  />
                </Suspense>
              )}
            />
          </Switch>
        </>
      )}
    </div>
  )
}
